import { SeatType } from '@cineamo/api/models/seat/SeatDto.types';

import { CinemaRoom, Seat, SeatCategory } from './typedefs';

const room: CinemaRoom = {
    id: 123,
    cinemaId: 1,
    name: 'Unnamed Cinema Hall',
    width: 15000,
    depth: 20000,
    height: 5000,
    basePrice: 1500,
    dto: {
        id: 123,
        cinemaId: 1,
        name: 'Unnamed Cinema Hall',
        isPrivateBookingEnabled: false,
        isTheater: false,
        isSyncDisabled: false,
        isHdmiPort: false,
        isVgaPort: false,
        isLanPort: false,
        isWlanPort: false,
        isDisplayportPort: false,
        isPowerConnection: false,
        is3DReady: false,
        isDolbyAtmosReady: false,
        isThxReady: false,
        isInfinityVisionReady: false,
        is5Point1Sound: false,
        is7Point1Sound: false,
        hasDboxSeats: false,
        hasLeatherSeats: false,
        hasPartnerSeats: false,
        hasVipRows: false,
        hasIncreasedRowSpacing: false,
        hasWheelchairSpaces: false
    }
};

const seatCategories: SeatCategory[] = [
    {
        id: 1,
        name: 'standard',
        priceChange: 1
    },
    {
        id: 2,
        name: 'premium',
        priceChange: 1.2
    },
    {
        id: 3,
        name: 'love',
        priceChange: 1.5
    },
    {
        id: 4,
        name: 'VIP',
        priceChange: 2
    }
];

const seats: Seat[] = [
    // row #1
    {
        id: 1,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 4209, y: -3429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        isLocked: false,
        isSelected: false,
        rowName: '1',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 2,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 2809, y: -3429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        isLocked: false,
        isSelected: false,
        rowName: '1',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 3,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 1409, y: -3429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '1',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 4,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 0, y: -3429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '1',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 5,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -1391, y: -3429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '1',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 6,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -2791, y: -3429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '1',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 7,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -4191, y: -3429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '1',
        positionName: '7',
        type: SeatType.SEAT
    },

    // row #2
    {
        id: 8,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 4209, y: -5229, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '2',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 9,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 2809, y: -5229, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '2',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 10,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 1409, y: -5229, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '2',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 11,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 0, y: -5229, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '2',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 12,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -1391, y: -5229, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '2',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 13,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -2791, y: -5229, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '2',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 14,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -4191, y: -5229, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '2',
        positionName: '7',
        type: SeatType.SEAT
    },

    // row #3
    {
        id: 15,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 4209, y: -7029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '3',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 16,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 2809, y: -7029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '3',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 17,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 1409, y: -7029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: true,
        isSelected: false,
        rowName: '3',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 18,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 0, y: -7029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '3',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 19,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -1391, y: -7029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '3',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 20,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -2791, y: -7029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '3',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 21,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -4191, y: -7029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '3',
        positionName: '7',
        type: SeatType.SEAT
    },

    // row #4
    {
        id: 22,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 4209, y: -8829, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '4',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 23,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 2809, y: -8829, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '4',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 24,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 1409, y: -8829, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '4',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 25,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 0, y: -8829, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '4',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 26,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -1391, y: -8829, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '4',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 27,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -2791, y: -8829, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '4',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 28,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -4191, y: -8829, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '4',
        positionName: '7',
        type: SeatType.SEAT
    },

    // row #5
    {
        id: 29,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 4209, y: -10629, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '5',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 30,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 2809, y: -10629, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '5',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 31,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 1409, y: -10629, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: true,
        isSelected: false,
        rowName: '5',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 32,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 0, y: -10629, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: true,
        isSelected: false,
        rowName: '5',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 33,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -1391, y: -10629, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: true,
        isSelected: false,
        rowName: '5',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 34,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -2791, y: -10629, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '5',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 35,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -4191, y: -10629, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '5',
        positionName: '7',
        type: SeatType.SEAT
    },

    // row #6
    {
        id: 36,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 4209, y: -12429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '6',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 37,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 2809, y: -12429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '6',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 38,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 1409, y: -12429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '6',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 39,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 0, y: -12429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '6',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 40,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -1391, y: -12429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '6',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 41,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -2791, y: -12429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '6',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 42,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -4191, y: -12429, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: '6',
        positionName: '7',
        type: SeatType.SEAT
    },

    // row #7
    {
        id: 43,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 4209, y: -14277, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '7',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 44,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 2809, y: -14277, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '7',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 45,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 1409, y: -14277, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '7',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 46,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 0, y: -14277, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '7',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 47,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -1391, y: -14277, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '7',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 48,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -2791, y: -14277, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: true,
        isSelected: false,
        rowName: '7',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 49,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -4191, y: -14277, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '7',
        positionName: '7',
        type: SeatType.SEAT
    },

    // row #8
    {
        id: 50,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 4209, y: -16029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '8',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 51,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 2809, y: -16029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '8',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 52,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 1409, y: -16029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '8',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 53,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 0, y: -16029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '8',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 54,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -1391, y: -16029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '8',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 55,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -2791, y: -16029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '8',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 56,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -4191, y: -16029, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: '8',
        positionName: '7',
        type: SeatType.SEAT
    },

    // col #right
    {
        id: 57,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 6706, y: -4550, z: 0 },
        rotation: { x: 0, y: 0, z: -40 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'R',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 58,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 6680, y: -6315, z: 0 },
        rotation: { x: 0, y: 0, z: -35 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'R',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 59,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 6656, y: -8079, z: 0 },
        rotation: { x: 0, y: 0, z: -30 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'R',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 60,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 6636, y: -9840, z: 0 },
        rotation: { x: 0, y: 0, z: -25 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'R',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 61,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 6620, y: -11600, z: 0 },
        rotation: { x: 0, y: 0, z: -20 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'R',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 62,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 6606, y: -13358, z: 0 },
        rotation: { x: 0, y: 0, z: -15 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: 'R',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 63,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 6597, y: -15115, z: 0 },
        rotation: { x: 0, y: 0, z: -10 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: 'R',
        positionName: '7',
        type: SeatType.SEAT
    },
    {
        id: 64,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: 6591, y: -16872, z: 0 },
        rotation: { x: 0, y: 0, z: -5 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: 'R',
        positionName: '8',
        type: SeatType.SEAT
    },

    // col #left
    {
        id: 65,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -6706, y: -4550, z: 0 },
        rotation: { x: 0, y: 0, z: 40 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'L',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 66,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -6680, y: -6315, z: 0 },
        rotation: { x: 0, y: 0, z: 35 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'L',
        positionName: '2',
        type: SeatType.SEAT
    },
    {
        id: 67,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -6656, y: -8079, z: 0 },
        rotation: { x: 0, y: 0, z: 30 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'L',
        positionName: '3',
        type: SeatType.SEAT
    },
    {
        id: 68,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -6636, y: -9840, z: 0 },
        rotation: { x: 0, y: 0, z: 25 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'L',
        positionName: '4',
        type: SeatType.SEAT
    },
    {
        id: 69,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -6620, y: -11600, z: 0 },
        rotation: { x: 0, y: 0, z: 20 },
        category: {
            id: 1,
            name: 'standard',
            priceChange: 1
        },
        isLocked: false,
        isSelected: false,
        rowName: 'L',
        positionName: '5',
        type: SeatType.SEAT
    },
    {
        id: 70,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -6606, y: -13358, z: 0 },
        rotation: { x: 0, y: 0, z: 15 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: 'L',
        positionName: '6',
        type: SeatType.SEAT
    },
    {
        id: 71,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -6597, y: -15115, z: 0 },
        rotation: { x: 0, y: 0, z: 10 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: 'L',
        positionName: '7',
        type: SeatType.SEAT
    },
    {
        id: 72,
        width: 1000,
        depth: 1000,
        height: 1500,
        position: { x: -6591, y: -16872, z: 0 },
        rotation: { x: 0, y: 0, z: 5 },
        category: {
            id: 2,
            name: 'premium',
            priceChange: 1.2
        },
        isLocked: false,
        isSelected: false,
        rowName: 'L',
        positionName: '8',
        type: SeatType.SEAT
    },

    // "love" seats
    {
        id: 73,
        width: 2400,
        depth: 1000,
        height: 1500,
        position: { x: 4550, y: -18799, z: 0 },
        rotation: { x: 0, y: 0, z: -20 },
        category: {
            id: 3,
            name: 'love',
            priceChange: 1.5
        },
        isLocked: false,
        isSelected: false,
        rowName: 'Love',
        positionName: '1',
        type: SeatType.SEAT
    },
    {
        id: 74,
        width: 2400,
        depth: 1000,
        height: 1500,
        position: { x: -4520, y: -18731, z: 0 },
        rotation: { x: 0, y: 0, z: 20 },
        category: {
            id: 3,
            name: 'love',
            priceChange: 1.5
        },
        isLocked: true,
        isSelected: false,
        rowName: 'Love',
        positionName: '2',
        type: SeatType.SEAT
    },

    // VIP seat
    {
        id: 75,
        width: 3800,
        depth: 1000,
        height: 1500,
        position: { x: 0, y: -18701, z: 0 },
        rotation: { x: 0, y: 0, z: 0 },
        category: {
            id: 4,
            name: 'VIP',
            priceChange: 2
        },
        isLocked: false,
        isSelected: false,
        rowName: 'VIP',
        positionName: '1',
        type: SeatType.SEAT
    }
];

// these are fallback colors, if SeatCategory.color is not defined
const seatColors = ['#00FFDC', '#FFA620', '#FFDE2E', '#6BAFFF'];

export { room, seatCategories, seats, seatColors };
